import request from "@/utils/request";
const querystring = require("querystring");

// 付费课表
export function getPayCourse(payload) {
  return request.get(`/hcp/teacherSpace/course/payClass`, {
    ...payload
  });
}

// 公开课表
export function getPublicCourse(payload) {
  return request.get(`/hcp/teacherSpace/course/publicClass`, {
    ...payload
  });
}

// svip课表
export function getSvipLessonPage(payload) {
  return request.post(`/hcp/teacherSpace/course/svipLessonPage`, {
    ...payload
  });
}

// 看直播
export function watchLive(payload) {
  return request.get(`/hcp/teacherSpace/course/watchLive`, {
    ...payload
  });
}

// 获取启动直播需要的数据
export function getLive(payload) {
  return request.get(`/hcp/teacherSpace/course/bootstrap`, {
    ...payload
  });
}

// 我的课程
export function getMyCourse(payload) {
  return request.get(`/hcp/teacherSpace/course/myCourse`, {
    ...payload
  });
}

// 我的课程-课程目录
export function getCatalog(payload) {
  return request.get(`/hcp/teacherSpace/course/courseCatalog`, {
    ...payload
  });
}

// 上传课件
export function uploadFile(payload) {
  return request.post(`/hcp/teacherSpace/course/uploadFile`, payload, {
    headers: { "content-type": "multipart/form-data" }
  });
}

// 上传课件到欢拓
export function uploadHtFile(payload) {
  return request.post(`/hcp/teacherSpace/course/htCoursewareUpload`, payload, {
    headers: { "content-type": "multipart/form-data" }
  });
}

// 我的课程-课程目录-看回放
export function lookVideo(payload) {
  return request.get(`/hcp/teacherSpace/course/watchRecording`, {
    ...payload
  });
}

// 我的课程-学员列表
export function getStudent(payload) {
  return request.get(`/hcp/teacherSpace/course/studetnList`, {
    ...payload
  });
}

// 我的课件
export function getCourseware(payload) {
  return request.get(`/hcp/teacherSpace/course/coursewareList`, {
    ...payload
  });
}

// 我的课件-添加课件
export function addWare(payload) {
  return request.post(`/hcp/teacherSpace/course/saveCourseware`, {
    ...payload
  });
}

// 我的课件-删除课件
export function delWare(payload) {
  return request.post(
    `/hcp/teacherSpace/course/delCourseware`,
    querystring.stringify({ ...payload }),
    { headers: { "content-type": "application/x-www-form-urlencoded" } }
  );
}

// 我的课件-课件模板列表
export function getTemplate(payload) {
  return request.post(`/hcp/teacherSpace/course/coursewareTemplate`, {
    ...payload
  });
}

// 获取加入码(百家云)
export function getJoinCode(payload) {
  return request.post(`/hcp/teacherSpace/course/getJoinCode`, {
    ...payload
  });
}

// 获取直播供应商信息(以及是否生活直播)
export function getSupplierInfo(payload) {
  return request.post(`/hcp/base/bjy/v1/getSupplierInfo`, {
    ...payload
  });
}

export function addLottery(payload) {
  return request.post(`/hcp/teacherSpace/course/addLottery`, {
    ...payload
  });
}

export function listLotteryRecords(payload) {
  return request.post(`/hcp/teacherSpace/course/listLotteryRecords`, {
    ...payload
  });
}


// WEBPACK FOOTER //
// ./src/services/course.js